import React from 'react'
import widgetService from 'live/services/widgets'
import { SrtWidgetReducer } from './SrtWidgetReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import i18n from 'live/services/i18n'
import { Configs, SrtMessage, SrtState } from './types/index'
import { withSuspenseWrapper } from '../../../SuspenseWrapper'

const WrapperSrtWidget = withSuspenseWrapper(React.lazy(() => import('./SrtWidget')))
const WrapperManagementSrtWidget = withSuspenseWrapper(React.lazy(() => import('./ManagementSrtWidget')))

widgetService.register({
    type: 'Rig Performance Index',
    get name() {
        return i18n('Summary Report Table')
    },
    get description() {
        return i18n('KPI - Rig Performance Index')
    },
    config: {
        color: 'green'
    },
    policies: {
        handleOwnMissingData: true
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<SrtState, SrtMessage, Configs>(WrapperSrtWidget, SrtWidgetReducer)
})

widgetService.register({
    type: 'Management Rig Performance Index',
    get name() {
        return i18n('Summary Management Report Table')
    },
    get description() {
        return i18n('KPI - Management Rig Performance Index')
    },
    config: {
        color: 'green'
    },
    policies: {
        handleOwnMissingData: true
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<SrtState, SrtMessage, Configs>(WrapperManagementSrtWidget, SrtWidgetReducer)
})
